import React from "react";
import {
  Button,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaCheckCircle, FaDownload, FaFileImage, FaFilePdf, FaLinkedin } from "react-icons/fa";

interface MobileActionBarProps {
  onDownload: () => void;
  onDownloadPdf: () => void;
  onLinkedIn: () => void;
  onVerify: () => void;
  isDownloadLoading: boolean;
  isPdfLoading: boolean;
  isDisabled: boolean;
  isIdCard: boolean;
}

// Fixed bottom bar shown below lg, where the sidebar ActionsCard is hidden
export const MobileActionBar: React.FC<MobileActionBarProps> = ({
  onDownload,
  onDownloadPdf,
  onLinkedIn,
  onVerify,
  isDownloadLoading,
  isPdfLoading,
  isDisabled,
  isIdCard,
}) => {
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Flex
      display={{ base: "flex", lg: "none" }}
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex={90}
      bg={bg}
      borderTopWidth={1}
      borderColor={borderColor}
      px={4}
      pt={3}
      pb="calc(12px + env(safe-area-inset-bottom))"
      gap={3}
    >
      <Button flex={1} colorScheme="red" leftIcon={<FaCheckCircle />} onClick={onVerify}>
        Verify
      </Button>

      <Menu placement="top">
        <MenuButton
          as={Button}
          flex={1}
          variant="outline"
          leftIcon={<FaDownload />}
          isLoading={isDownloadLoading || isPdfLoading}
          isDisabled={isDisabled}
        >
          Download
        </MenuButton>
        <MenuList>
          <MenuItem icon={<FaFileImage />} onClick={onDownload}>
            Image
          </MenuItem>
          <MenuItem icon={<FaFilePdf />} onClick={onDownloadPdf}>
            PDF
          </MenuItem>
        </MenuList>
      </Menu>

      {!isIdCard && (
        <Tooltip label="Add to LinkedIn">
          <IconButton aria-label="Add to LinkedIn" colorScheme="linkedin" icon={<FaLinkedin />} onClick={onLinkedIn} />
        </Tooltip>
      )}
    </Flex>
  );
};
